import type { ActivityResponse } from '@stream-io/feeds-client'

import { Post, PostType } from './Post'

const isPostType = (type: string): type is PostType => (
    type === PostType.default || type === PostType.announcement
)

export const transformActivityToPost = (activity: ActivityResponse): Post => ({
    id: activity.id,
    type: isPostType(activity.type) ? activity.type : PostType.default,
    title: activity.custom.title,
    text: activity.text,
    images: activity.attachments
        .filter(attachment => attachment.type === 'image')
        .map(attachment => attachment.image_url ?? attachment.asset_url)
        .filter((url): url is string => Boolean(url)),
    author: {
        id: activity.user.id,
        name: activity.user.name,
        image: activity.user.image,
    },
    createdAt: activity.created_at,
    likeCount: activity.reaction_groups.like?.count ?? 0,
    hasLiked: activity.own_reactions.some(reaction => reaction.type === 'like'),
    heartCount: activity.reaction_groups.heart?.count ?? 0,
    hasHearted: activity.own_reactions.some(reaction => reaction.type === 'heart'),
    commentCount: activity.comment_count,
})
